module.exports = __webpack_public_path__ + "media/images/top/img-top-oyu-db646802a416fb2a84c8e213f9d1e87a.jpg";